import { ApplicationFilters } from "@/model/applications";
import { SortingTypes } from "@/helpers/SortingTypes";

export const defaultApplicationFilterFields: ApplicationFilters = {
  search: "",
  channel_id: "",
  customer_id: "",
  project_id: "",
  "status[]": undefined,
  created_by: "",
  created_at_from: "",
  created_at_to: "",
  limit: "20",
  offset: "0",
  sort_column: "application.created_at",
  sort_direction: SortingTypes.DESC,
};
